
import AzIcon from '~/components/_next/atoms/AzIcon.vue';

export default {
  name: 'FileForDownload',
  components: { AzIcon },
  props: {
    file: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const redirectToFile = () => window.open(props.file.fields.file.url, '_blank');
    return { redirectToFile };
  },
};
